export class Constants {
  static readonly CdfAdminRole = 'CDFAdministrators';
  static readonly AdminPageRole = 'Admin';
  static readonly DirectoryEmpty = 'Directory empty';
  static readonly TimeOutError = 'Time out. Try again later';
  static readonly LogoDark = 'assets/images/CDF_Horizontal_Black.png';
  static readonly LogoLight = 'assets/images/CDF_Horizontal_White_Transparent.png';
  static readonly ckeToolbarConfig = [
    { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
    { name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'] },
    { name: 'forms', items: ['Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField'] },
    '/',
    {
      name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-',
        'CopyFormatting', 'RemoveFormat']
    },
    {
      name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-',
        'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language']
    },
    { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
    { name: 'insert', items: ['Image', 'Table', 'HorizontalRule'] },
    '/',
    { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
    { name: 'colors', items: ['TextColor', 'BGColor'] },
    { name: 'tools', items: ['Maximize', 'ShowBlocks', 'Source'] },

    { name: 'about', items: ['About'] }
  ];

  static readonly cdfRemoveButtons = 'ExportPdf,NewPage,Save,Preview,Templates,PasteFromWord,Replace,SelectAll,Form,' +
    'TextField,Button,ImageButton,Textarea,Radio,Select,HiddenField,Checkbox,RemoveFormat,' +
    'Blockquote,CreateDiv,Language,ShowBlocks,Maximize';
  static readonly cdkExtraPlugings = ['preview', 'colordialog', 'floatpanel', 'dialog', 'table', 'tabletools', 'tableresize',
    'clipboard', 'tableselection', 'colorbutton', 'format', 'font']

  static readonly cdfDocumentGridLayout = [
    { id: 1, x: 0, y: 0, w: 6, h: 3, title: 'Documentation', content: '' },
    { id: 2, x: 0, y: 3, w: 3, h: 3, title: 'Shipping Rates for CDF', content: '' },
    { id: 6, x: 3, y: 3, w: 3, h: 3, title: 'Shipping Rates for CDF 1', content: '' },
    { id: 3, x: 0, y: 6, w: 3, h: 3, title: 'Sample Packing Slips and Billing', content: '' },
    { id: 4, x: 0, y: 9, w: 3, h: 3, title: 'CDF Product Data', content: '' },
    { id: 5, x: 0, y: 12, w: 3, h: 2, title: 'Order Response File', content: '' },
    { id: 7, x: 3, y: 6, w: 3, h: 2, title: 'CDF Ordering Methods', content: '' },
    { id: 8, x: 3, y: 9, w: 3, h: 2, title: 'Customer Service Tool', content: '' }
  ];

}

export enum CdfRoles {
  devadmin = 'devadmin',
  aecadmin = 'aecadmin',
  cdfadmin = 'cdfadmin'
}
